
// const host = window.location.host;
//  const tenant_name = host.split('.')[0];
// const tenant_name = 'nimble';

// export const apiUrl = `http://${tenant_name}.localhost:8000/api`;
export const apiUrl = `https://uat-api.itstaste.com/api`;
export const defaultPagination = 10;
export const perPageList =  [20, 50, 100];

export const APP_NAME = 'nimble';
export const APP_PORTAL = 'customer';
export const APP_TENANT = 'nimble';
export const APP_PUSHER_KEY = 'ac822ec57919117792dd'
